import {
  Box,
  // Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";
import CodeIcon from "@mui/icons-material/Code";
import { useTheme } from "@mui/material/styles";
import { LabList } from "../Data/LabList";

type LabProps = { isSmallScreen: boolean };

function Lab(props: LabProps) {
  const theme = useTheme();

  return (
    <Box sx={{ py: 6 }}>
      <Typography variant="h1" fontWeight={700}>
        <span style={{ color: theme.palette.secondary.main }}>Lab</span> /
        Experiments
      </Typography>
      <Grid container spacing={3}>
        {LabList.map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item.id}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${theme.palette.divider}`,
                transition: "transform 0.2s",
                "&:hover": { transform: "scale(1.02)" },
              }}
            >
              {item.image ? (
                <CardMedia
                  component="img"
                  height="160"
                  image={item.image}
                  alt={item.title}
                  sx={{ objectFit: "cover" }}
                />
              ) : (
                <Box
                  sx={{
                    height: 160,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(26, 174, 255, 0.08)",
                    borderBottom: `1px solid ${theme.palette.divider}`,
                  }}
                >
                  <CodeIcon sx={{ fontSize: 64, color: theme.palette.secondary.main, opacity: 0.5 }} />
                </Box>
              )}
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h3" sx={{ py: 0, mb: 0.5 }}>
                  {item.title}
                </Typography>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  {item.description}
                </Typography>
                {/* <Button
                  size="small"
                  variant="outlined"
                  href={item.url}
                  target="_blank"
                  sx={{
                    borderColor: theme.palette.secondary.main,
                    textTransform: "none",
                  }}
                >
                  {item.url.includes("vercel") ? "Live Demo" : "GitHub"}
                </Button> */}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default Lab;
